<template>
  <Dcp>
    <!-- <label class="theme-class">测试主题</label> -->
    <!-- <el-button @click="switchLan" type="primary">{{$t('elementMsg.cascader.loading')}}切换语言</el-button> -->
    <!-- <el-button class="theme-btn" @click="toggleDark" type="primary">切换主题{{ isDark  }}</el-button> -->
    <div @toggleDark="toggleDark" :isDark="isDark" class="main-routerview-wrap">
      <!-- <button @click="loginWithDingTalk">钉钉登录</button> -->
      <RouterView />
    </div>
    <!-- <Footer></Footer> -->

  </Dcp>
</template>
<script setup>
  import { ref, onMounted, inject, reactive } from 'vue'
  import { RouterView, useRoute } from 'vue-router'
  import Dcp from './DiyConfigProvider.vue'
  import store from '@store/index'
  // import { useI18n } from 'vue-i18n'
  import { useDark, useToggle } from '@vueuse/core'
  import Footer from './layouts/footer.vue'

const $axios = inject('$axios')

  const $route = useRoute()



  const isDark = useDark({
    selector: 'html',
    attribute: 'class',
    valueDark: 'dark',
    valueLight: 'light',
  })

  onMounted(() => {
  })
  const toggleDark = () => {
    const t = useToggle(isDark)
    return t()
  }

  const dingLoginByCode = async (code, redirectUrl) => {
    if (code && redirectUrl) {
      window.location.href = redirectUrl
      return
    }
    if (!code) {
      return
    }
    const url = `/proxyApi/user/loginbydingding?code=${code}`
    const res = await $axios.post(url)
    if (res.code == 0) {
      if (redirectUrl) {
        window.location.href = redirectUrl
      } else {
        window.location.reload()
      }
    }

  }


 
  const loginWithDingTalk = () => {
    // goCodeLogin()
    // ddLoginIns()
    const appId = 'dingkcmn8ngipph4sp90';
    const redirectUri = encodeURIComponent('https://iotai.xiziipark.com');
    const url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&redirect_uri=${redirectUri}`;
    
    window.location.href = url;
  }

  async function getConfig () {
    if (window.electronAPI) {
      let config = await window.electronAPI.getConfig();
      console.log('config', config)
      localStorage.electronConfig = JSON.stringify(config || '{}')
    }
  }
  getConfig()


  localStorage.baseUrl = store.state.BASE_URL
  // const i18nInstance = useI18n()
  // const isDark = useDark({
  //   selector: 'html',
  //   attribute: 'class',
  //   valueDark: 'dark',
  //   valueLight: 'light',

  // })
  const switchLan = () => {
    const lan = store.state.lan == 'en' ? 'zh-cn' : 'en'
    i18nInstance.locale.value = lan
    store.commit('changeLan', lan)
  }

  // const toggleDark = () => {
  //   const t = useToggle(isDark)
  //   return t()
  // }

</script>
<style lang="scss">
.el-dialog__header {
  margin-right: 0px;
}
.el-dialog {
  border-radius: 8px;
}
.theme-btn {
  position: fixed;
  top: 0;
  left: 0;
}
.top-logo {
  height: 75px;
  background-color: var(--body-bg-color);
}
.main-routerview-wrap {
  // height: 100vh;
  // padding: 0 17px;
  background-color: var(--body-bg-color);
}
</style>
